/**
 * The LayerManager wraps your application and creates two adjacent divs for
 * rendering your application and housing Layers.
 */
import * as React from "react"
import FocusContext from "./FocusContext"

type Props = Readonly<{
  children: React.ReactNode
}>

const FocusManager = ({ children }: Props) => {
  const [activeTraps, setActiveTraps] = React.useState<
    React.ContextType<typeof FocusContext>["activeTraps"]
  >(new Map())

  return (
    <FocusContext.Provider value={{ activeTraps, setActiveTraps }}>
      {children}
    </FocusContext.Provider>
  )
}

export default React.memo(FocusManager)
